import { ErpData, ErpDataLite } from "./erp-data.interface";
import { RoleType } from "./role.interface";
import { PagingModelV2 } from "./pagination.interface";
import { Province, ProvinceV2 } from "./province.interface";

export class User {
    address: DeliveryAddress;
    businessName: string;
    businessRegistrationCert?: string[];
    businessRegistrationCertPending?: string[];
    businessRegistrationCert2?: string[];
    businessRegistrationCert2Pending?: string[];
    createdBy?: string;
    createdDate?: Date;
    district?: string;
    doB?: Date;
    email: string;
    fullName?: string;
    gender?: number;
    id?: string;
    status?: UserStatus | string;
    lastModifiedDate?: Date;
    modifiedBy?: string;
    businessType: BusinessType;
    permissions?: number[] | undefined;
    pharmaceuticalStandard?: string[];
    pharmaceuticalStandardPending?: string[];
    phone: string;
    province?: string;
    referer: string;
    roles?: Role[] | any;
    userName: string;
    ward?: string;
    taxNumber: string;
    erpName?: string;
    deliveryAddress?: DeliveryAddress[];
    isReviewRequested?: boolean;
    confirmStatus?: ConfirmUserStatus;
    password: string;
    giftPoint: number;
    spinRemaining?: number;
    canBeParent?: boolean;
    parent?: string;
    childrens?: ChildrenModel[];
    businessRegistrationCertData: DocumentData;
    businessRegistrationCert2Data: DocumentData;
    pharmaceuticalStandardData: DocumentDataGPP;
    pharmaceuticalStandardItems?: DocumentDataListGPP[];
    pharmaceuticalStandardItemsPending?: DocumentDataListGPP[]
    vdxErp?: ErpData;
    userSupports?: UserSupport[];
    userSupport_SalePerson?: EmployeeModel;
    userSupport_MarkerDev?: EmployeeModel;
    userSupport_ProcessOrder?: EmployeeModel;
    userSupport_Logistic?: EmployeeModel;
    customerGroupErpId?: string;
    erpCustomerGroupId?: string;
    dataSource?: string;
    pharmacyChainId?: number;
    budgetRelationShipCode?: string;
    pharmaceuticalDatabaseCode?: string;
    buyerName?: string;
    isAutoUpdateBusinessNameWhenPushErp?: boolean;
    isSyncToErp?: boolean;

    static getSalePerson(user: User): UserSupport | undefined {
        if (user.userSupports && user.userSupports.length) {
            return user.userSupports.find(p => p.userSupportType == UserSupportType.SalePerson);
        }
        return undefined;
    }
    static getMarkerDev(user: User): UserSupport | undefined {
        if (user.userSupports && user.userSupports.length) {
            return user.userSupports.find(p => p.userSupportType == UserSupportType.MarkerDev);
        }
        return undefined;
    }
    static getProcessingOrder(user: User): UserSupport | undefined {
        if (user.userSupports && user.userSupports.length) {
            return user.userSupports.find(p => p.userSupportType == UserSupportType.ProcessingOrder);
        }
        return undefined;
    }
}
export type UserAdminUpdatePayload = Omit<Partial<User>, 'roles'> & {
    roles?: Pick<Role, 'id' | 'roleName'>[];
};

export enum ConfirmUserStatus {
    Ok = 0,
    Pending = 1,
    Rejected = 2
}
export enum ExportUserFieldLabel {
    UserName = 'Tên đăng nhập',
    FullName = 'Fullname',
    Status = 'Tier',
    CreatedDate = 'Ngày tạo tài khoản',
    DoB = 'Sinh nhật',
    Email = 'Email',
    BusinessType = 'Hình thức kinh doanh',
    BusinessName = 'Tên hồ sơ kinh doanh',
    Phone = 'SĐT liên hệ',
    Province = 'Tỉnh',
    Referer = 'Người giới thiệu',
    Roles = 'Role',
    TaxNumber = 'Mã số thuế',
    ErpName = 'Tên ERP',
    ErpPartnerCode = 'Mã ERP',
    DocumentBusinessRegistrationNo = 'Số giấy phép DKKD',
    DocumentBusinessRegistrationNo2 = 'Số giấy phép đủ điều kiện ĐKKD ',
    PharmaceuticalStandardNo = 'Số giấy phép GPP',
    BusinessRegistrationCert = 'Đăng ký kinh doanh',
    BusinessRegistrationCert2 = 'Đủ điều kiện đăng ký kinh doanh',
    PharmaceuticalStandard = 'GPP',
    GppDate = 'Ngày hết hạn GPP',
    SalePerson = 'Nhân viên kinh doanh',
    ProcessingOrder = 'Nhân viên xử lý đơn',
    MarkerDev = 'Nhân viên phát triển',
    MembershipType = 'Chương trình thành viên'
}

export class DeliveryAddress {
    id?: string;
    address: string;
    province?: Province;
    provinceV2?: ProvinceV2;
    receiverName: string;
    receiverPhone: string;
    status: StatusAddress = 1;
    erpAddressCode?: string;
    vdxErp?: ErpDataLite;
    confirmStatus?: ConfirmUserStatus;
}

export enum StatusAddress {
    Default = 0,
    Active = 1,
    Inactive = 2
}

export enum BusinessType {
    Drugstore = 0,
    Drugstores = 1,
    MedicineCabinet = 2,
    WholesaleFacility = 3,
    Hospital = 4,
    OtherMedicalTreatmentFacilities = 5,
    Other = 6
}

export interface Role {
    roleType?: RoleType;
    priority?: number;
    createdBy: string;
    createdDate: Date;
    id: string;
    isActive: boolean;
    lastModifiedBy?: string;
    lastModifiedDate?: Date;
    permissions: number[];
    roleName: string;
}

export enum UserStatus {
    None = 0,
    Active = 1,
    Inactive = 2,
    Pending = 3,
    Tier1 = 4,
    Tier2 = 5,
}

export class UserPagingModel extends PagingModelV2 {
    statusIds?: number[] = [0];
    roleIds?: string[] = [''];
    membershipType?: string[] = [''];
    provinceCode?: number;
    selectedExportFields: string[] = [];
    fromDate?: Date;
    toDate?: Date;
    userSupport_SalePerson_Id?: number = -1;
    hasUnconfirmedAddress?: boolean;
}

export interface DeliveryAddressModel {
    deliveryAddress: DeliveryAddress[];
    userName: string;
}


export class BusinessProfile {
    userName: string;
    businessType: string;
    businessName: string;
    taxCode: string;
    province: string;
    district: string;
    ward: string;
    address: string;
    businessLicenses: File[] = [];
    businessCertifications: File[] = [];
    distributionCertifications: File[] = [];
}

export interface PointUsage {
    point: number;
    usedDate: string;
    orderId: string;
    pointDetail: ItemPointUsage;
    userUpdate: string;
    xPickingPartner: string;
    branchCode: string;
    id: string;
    lastUpdate: string;
}

export interface ItemPointUsage {
    productId: number;
    quantity: number;
    point: number;
}
export class TransportPaymentData {
    name: string;
    codeTransport: string;
    paymentTerm: PaymentTerm[];
}

export class PaymentTerm {
    name: string;
    code: string;
}

/** Transport V2 — response từ GET /api/v1/onbehalfuser/user/transport?deliveryAddressId=<id> */
export interface PaymentMethodV2 {
    code: string;
    name: string;
}

export interface TransportV2 {
    transportId: number;
    code: string;
    name: string;
    description: string;
    paymentMethod: PaymentMethodV2[];
    /** Thời gian giao hàng dự kiến; có thể null */
    estimatedDeliveryTime: string | null;
}

export class ChildrenModel {
    userName: string;
    status: ChildrenActiveStatus;
}

export enum ChildrenActiveStatus {
    Active = 1,
    Inactive = 99,
}

export class CreateChildAccountModel {
    parentUserName: string;
    childUserName: string;
    password: string;
}

export class RemoveChildAccountModel {
    parentUserName: string;
    childUserName: string;
}

export interface DocumentData {
    documentNo?: string;
    issuedDate?: string;
    issuedPlace?: number;
}

export interface DocumentDataGPP extends DocumentData {
    expireDate?: string;
    businessScopes?: BusinessScope[];
}

export interface DocumentDataListGPP extends DocumentDataGPP {
    pharmaceuticalStandard?: string;
}

export enum BusinessScope {
    GeneralProduct = 0, //TBYT, TPCN, Dược Mỹ Phẩm
    RegularNonPrescription = 1, //Thuốc thường không kê đơn
    RegularPrescription = 2, //Thuốc thường kê đơn
    EssentialPrescriptionDrug = 3, //Thuốc thường kê đơn thiết yếu
    NarcoticCombinationPrescription = 4, //Thuốc phối hợp chứa dược chất gây nghiện kê đơn
    NarcoticCombinationNonPrescription = 5, //Thuốc phối hợp chứa dược chất gây nghiện không kê đơn
    PsychotropicCombinationPrescription = 6, //Thuốc phối hợp chứa dược chất hướng thần kê đơn
    PsychotropicCombinationNonPrescription = 7, //Thuốc phối hợp chứa dược chất hướng thần không kê đơn
    PrecursorCombinationPrescription = 8, //Thuốc phối hợp chứa tiền chất  kê đơn
    PrecursorCombinationNonPrescription = 9, //Thuốc phối hợp chứa tiền chất không kê đơn
    ProhibitedInIndustriesPrescription = 10, //Thuốc cấm sử dụng trong 1 số ngành kê đơn
    ProhibitedInIndustriesNonPrescription = 11, //Thuốc cấm sử dụng trong 1 số ngành không kê đơn
    EssentialProhibitedInIndustriesPrescription = 12, //Thuốc cấm sử dụng trong 1 số ngành kê đơn thiết yếu
    BiologicProduct = 13, //Sinh phẩm
}
export class UserSupport {
    userName: string;
    userSupportType: UserSupportType;
    createdAt: string;
    updatedAt: string | undefined;
    erpId?: string;
}

export enum UserSupportType {
    SalePerson = 1,
    MarkerDev = 2,
    ProcessingOrder = 3,
    Logistic = 4
}

export class EmployeeModel {
    id: number;
    name: string;
    login: string;
    active: boolean;
}

export interface PharmacyChain {
    erpId: number;
    code: string;
    name: string;
}

export interface CustomerGroup {
    erpId: string;
    name: string;
    company: string;
    erpRecordId: string;
}

export interface UserGiftExchanged {
    recordId: string;
    name: string;
    giftId: string;
    sku: string;
    imageUrls: string[];
    description: string;
    exchangedQuantity: number;
    exchangedAt: Date;
    cost: number;
    redeemInput: number;
}

export interface TaxValidationData {
    id: string;
    taxCode: string;
    companyName: string;
    address: string;
    activeStatus: string;
    checkedBy: string;
    lastCheckedAt: string;
    rawResponse: string;
}

export interface BaseResponseModel<T = any> {
    data: T | null;
    isSuccess: boolean;
    message: string;
}

export interface TaxCheckResponse extends BaseResponseModel<TaxValidationData> {
}

export interface RedeemGiftRequest {
    userName: string;
    gifts: RedeemGiftMetadata[];
}

export interface RedeemGiftMetadata {
    recordId: string;
    giftId: string;
    quantity: number;
}

export interface UpdateAddressStatusRequest {
  userName: string | null;
  addressId: string | null;
  confirmStatus: number;        // 0: Ok (Duyệt), 1: Pending, 2: Rejected (Từ chối)
  confirmNote?: string | null;
}

export enum ImportCsStaffJobStatus {
  Pending = 0,
  Running = 10,
  Completed = 20,
  Failed = 30,
}

export interface ImportCsStaffError {
  row: number;
  column: string;
  message: string;
}

export interface ImportCsStaffJob {
  jobId: string;
  fileName: string;
  status: ImportCsStaffJobStatus;
  totalRows: number;
  processedRows: number;
  validRows: number;
  invalidRows: number;
  progressPercentage: number;
  errors: ImportCsStaffError[];
  errorsTruncated: boolean;
  message: string;
  createdAt: string;
  startedAt: string | null;
  completedAt: string | null;
}

export interface ImportCsStaffData {
  userName: string | null;
  id: number | null;
  name: string;
  salesStaffName: string | null;
  salesStaffId: number | null;
  developmentStaffName: string | null;
  developmentStaffId: number | null;
  orderProcessingStaffName: string | null;
  orderProcessingStaffId: number | null;
}

export interface ImportCsStaffJobRow {
  id: string;
  jobId: string;
  row: number;
  isSuccess: boolean;
  data: ImportCsStaffData;
  errors: ImportCsStaffError[];
}

export interface ImportCsStaffResultPage {
  jobId: string;
  isSuccess: boolean;
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  items: ImportCsStaffJobRow[];
}

export interface ImportCsStaffReadingError {
  row: number;
  column: string;
  message: string;
}

export interface ImportCsStaffReadingResult {
  totalRows: number;
  validRows: number;
  invalidRows: number;
  data: ImportCsStaffData[];
  errors: ImportCsStaffReadingError[];
}
